export default __webpack_public_path__ + "static/media/Jaymie_Stein.3592a48a.png";